import { useTrips } from '@hooks'
import { Trip } from '@types'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import JoinTripModal from './JoinTripModal'
import TripsList from './TripsList'

const TripsPage: React.FC = () => {
	const navigate = useNavigate()
	const { data: tripsData, isLoading, error } = useTrips()
	const [isJoinModalOpen, setIsJoinModalOpen] = useState(false)

	const handleTripClick = (trip: Trip) => {
		navigate(`/trips/${trip.id}`)
	}

	const handleCreateTrip = () => {
		navigate('/trips/create')
	}

	const handleJoinTrip = () => {
		setIsJoinModalOpen(true)
	}

	return (
		<>
			<TripsList
				trips={tripsData?.trips || []}
				loading={isLoading}
				error={error ? 'Failed to load trips' : null}
				onTripClick={handleTripClick}
				onCreateTrip={handleCreateTrip}
				onJoinTrip={handleJoinTrip}
			/>
			<JoinTripModal isOpen={isJoinModalOpen} onClose={() => setIsJoinModalOpen(false)} />
		</>
	)
}

export default TripsPage
